import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// components
import { CloseIcon, Modal } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// themes
// types
import { ICompany } from 'types/graphql'
// views
import { CompaniesContainer, CompanyWrapper, Container, Header } from './views'

const AuthCompanySelectModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, width, resolve, companies }
  } = useModalData({ modalType: Modals.AUTH_COMPANY_SELECT_MODAL })

  const onCompanySelect = (id: string) => () => {
    resolve(id)
    hideModal()
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal hideModal={hideModal} isOpen={isOpen} width={width} PaperProps={{ style: { width: '554px' } }}>
      <Container>
        <Header>
          <span>Select Company</span>
          <CloseIcon onClick={hideModal} />
        </Header>
        <CompaniesContainer>
          {companies.map((item: ICompany) => (
            <CompanyWrapper key={item.id} onClick={onCompanySelect(item.id)}>
              <div>{item.name}</div>
              <div>{item.domainName}</div>
            </CompanyWrapper>
          ))}
        </CompaniesContainer>
      </Container>
    </Modal>
  )
}

export default AuthCompanySelectModal
